import moment from 'moment';
import { FiRefreshCw, FiRotateCcw, FiChevronLeft, FiChevronRight, FiGrid } from 'react-icons/fi';
import { Card, CardBody, Col, Container, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import GeneralButton from '../../components/button/GeneralButton';
import DnhJobsTable from '../../components/table/DnhJobsTable';
import useDnhJobs from './customHooks/useDnhJobs';
import { Spin } from "antd";
const DnhJobs = () => {
    const { 
        jobs, 
        page, 
        totalPages, 
        setPage, 
        viewDetails, 
        toggleRollbackModal, 
        handleTriggerSync, 
        handleRollback, 
        rollbackModal, 
        selectedJobId, 
        setSelectedJobId, 
        rollbackLoading, 
        syncLoading,
        loading 
    } = useDnhJobs();

    return (
        <div className="settings-container">
            <div className="px-4">
                {/* Header Section */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div className="d-flex align-items-center gap-3">
                        <div className="bg-primary-soft p-3 rounded-circle shadow-sm">
                            <FiGrid size={24} className="text-primary" />
                        </div>
                        <div>
                            <h4 className="fw-bold text-dark mb-0">DNH Jobs Management</h4>
                            <p className="text-muted small mb-0">Sync & Import History Overview</p>
                        </div>
                    </div>
                    <div className="d-flex gap-3">
                        <GeneralButton
                            title={"Rollback Job"}
                            className={"btn-action bg-white text-dark border shadow-sm px-3"}
                            handleClick={toggleRollbackModal}
                            icon={<FiRotateCcw className="me-2" />}
                        />
                        <GeneralButton
                            title={"Trigger DNH Sync"}
                            className={"create-user-btn text-white shadow-sm px-4"}
                            handleClick={handleTriggerSync}
                            loading={syncLoading}
                            icon={<FiRefreshCw className="me-2" />}
                        />
                    </div>
                </div>

                <div className="settings-card">
                    {loading ? (
                        <div className="text-center py-5">
                            <Spin size="large" />
                        </div>
                    ) : (
                        <>
                            <DnhJobsTable data={jobs} viewDetails={viewDetails} />

                            {/* Pagination */}
                            <div className="d-flex justify-content-between align-items-center mt-4 pt-3 border-top">
                                <p className="text-muted small mb-0">
                                    Page <span className="fw-bold text-dark">{page}</span> of <span className="fw-bold text-dark">{totalPages}</span>
                                </p>
                                <div className="d-flex gap-2">
                                    <GeneralButton
                                        title={<FiChevronLeft />}
                                        className="btn-action bg-white border"
                                        handleClick={() => setPage(p => Math.max(1, p - 1))}
                                        disabled={page === 1}
                                    />
                                    <GeneralButton
                                        title={<FiChevronRight />}
                                        className="btn-action bg-white border"
                                        handleClick={() => setPage(p => p + 1)}
                                        disabled={page >= totalPages}
                                    />
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>

            {/* Rollback Modal */}
            <Modal isOpen={rollbackModal} toggle={toggleRollbackModal} centered contentClassName="border-0 shadow-lg" size="md">
                <ModalHeader toggle={toggleRollbackModal} className="border-bottom-0 pb-0">
                    <h5 className="fw-bold text-dark">Rollback DNH Import Job</h5>
                </ModalHeader>
                <ModalBody className="py-4">
                    <p className="text-muted mb-4 small">Select a previously completed job to rollback its changes. This action will undo the product updates from that specific sync.</p>
                    <FormGroup>
                        <Label className="small fw-600 text-muted mb-1">Select Job to Rollback</Label>
                        <Input
                            type="select"
                            className="form-control-lg border rounded-3 shadow-none small"
                            value={selectedJobId}
                            onChange={(e) => setSelectedJobId(e.target.value)}
                        >
                            <option value="">-- Choose a Completed Job --</option>
                            {jobs.filter(j => j.status?.toLowerCase() === 'completed').map(job => (
                                <option key={job.jobId || job.id} value={job.jobId || job.id}>
                                    ID: {job.jobId || job.id} — {
                                        job.timestamps?.createdAt
                                            ? moment(job.timestamps.createdAt).format('MMM DD, YYYY HH:mm')
                                            : (job.createdAt ? moment(job.createdAt).format('MMM DD, YYYY HH:mm') : '')
                                    } ({job.type?.replace(/_/g, ' ')})
                                </option>
                            ))}
                        </Input>
                    </FormGroup>
                </ModalBody>
                <ModalFooter className="border-top-0 pt-0 pb-4">
                    <GeneralButton
                        title="Cancel"
                        className="btn-action bg-light text-dark border-0 px-4"
                        handleClick={toggleRollbackModal}
                    />
                    <GeneralButton
                        title="Confirm Rollback"
                        className="create-user-btn px-4"
                        handleClick={handleRollback}
                        loading={rollbackLoading}
                        disabled={!selectedJobId}
                    />
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default DnhJobs;
